import HEADER from "../Components/header";
import { useEffect } from 'react';
import { Link,useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';

const Topmenu = () => {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const accessToken = cookies.access_token;
    const authorityToken = cookies.authority;

    useEffect(() => {
        if(!accessToken || authorityToken !== 1) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
    }, []);

    return (
        <div className="wrapper">
            <HEADER />
            <main className="main">
                <section className="page-head" id="page-head">
                    <div className="page-head-block">
                        <div className="page-name">
                            {/*<a onClick={() => navigate(-1)}><img src={BACK} alt="戻る" /></a>*/}
                            <div className="page-name-label">トップメニュー</div>
                        </div>
                    </div>
                </section>
                <section className="page-body scroll-block">
                    <div className="menu-box">
                        <Link to="/gateway_admin" className="menu-item menu-gateway">Gateway管理</Link>
                        <Link to="/sensor_admin" className="menu-item menu-sensor">センサ管理</Link>
                        <Link to="/site_admin_list" className="menu-item menu-genba">現場一覧</Link>
                        <Link to="/info_admin" className="menu-item menu-information">お知らせ管理</Link>
                    </div>
                </section>
            </main>
        </div >
    );
};
export default Topmenu;
